import Resource from './common/resource';

class Messages extends Resource {
  path = 'messages';
}

export default Messages;
